/* Fake Fruit — global JS */

/* Aviso de "adicionado" com caminho para frente.
   Antes, o unico retorno era o botao virar "Adicionado" por 1,4s e o contador
   no topo mudar. No celular a pessoa nao ve o topo, e nao tinha nenhum convite
   para ir ao carrinho. Este aviso fica no rodape, ao lado do WhatsApp, e leva. */
window.ffAviso = (function(){
  var cx = null, timer = null;
  function css(){
    if (document.getElementById('ff-aviso-css')) return;
    var s = document.createElement('style');
    s.id = 'ff-aviso-css';
    s.textContent = [
      '.ff-aviso{position:fixed;z-index:320;left:12px;right:84px;bottom:18px;',
      '  display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:12px;',
      '  background:rgba(10,15,17,.97);border:1px solid rgba(0,229,255,.35);',
      '  box-shadow:0 12px 34px rgba(0,0,0,.5);backdrop-filter:blur(8px);',
      '  transform:translateY(130%);transition:transform .26s ease;}',
      '.ff-aviso.ff-aviso-on{transform:translateY(0)}',
      '.ff-aviso-txt{flex:1;min-width:0;font-size:13.5px;line-height:1.35;color:#e8edeb}',
      '.ff-aviso-txt b{display:block;color:#fff;font-size:14px}',
      '.ff-aviso-btn{flex:0 0 auto;padding:9px 14px;border-radius:8px;background:#00e5ff;',
      '  color:#05282e;font-weight:800;font-size:12px;text-decoration:none;white-space:nowrap}',
      '.ff-aviso-x{flex:0 0 auto;border:0;background:none;color:#7d8a91;font-size:18px;',
      '  line-height:1;padding:2px 4px;cursor:pointer}',
      '@media(min-width:761px){.ff-aviso{left:auto;right:100px;max-width:420px}}'
    ].join('');
    document.head.appendChild(s);
  }
  return function(titulo, linha){
    css();
    if (!cx){
      cx = document.createElement('div');
      cx.className = 'ff-aviso';
      cx.setAttribute('role','status');
      cx.setAttribute('aria-live','polite');
      document.body.appendChild(cx);
    }
    cx.innerHTML = '';
    var t = document.createElement('div');
    t.className = 'ff-aviso-txt';
    t.innerHTML = '<b></b><span></span>';
    t.querySelector('b').textContent = titulo;
    t.querySelector('span').textContent = linha || '';
    var a = document.createElement('a');
    a.className = 'ff-aviso-btn';
    a.href = '/cart';
    a.textContent = 'Ver carrinho';
    var x = document.createElement('button');
    x.className = 'ff-aviso-x';
    x.type = 'button';
    x.setAttribute('aria-label','Fechar');
    x.textContent = '×';
    x.addEventListener('click', function(){ cx.classList.remove('ff-aviso-on'); });
    cx.appendChild(t); cx.appendChild(a); cx.appendChild(x);
    requestAnimationFrame(function(){ cx.classList.add('ff-aviso-on'); });
    clearTimeout(timer);
    timer = setTimeout(function(){ cx.classList.remove('ff-aviso-on'); }, 6500);
  };
})();

(function(){
  // Add to cart from product cards (AJAX)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adicionando...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      btn.textContent = '✓ Adicionado';
      setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 1400);
      // refresh cart count
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var n = c.item_count;
        var plural = n === 1 ? '1 item no carrinho' : n + ' itens no carrinho';
        if (window.ffAviso) window.ffAviso('Adicionado ao carrinho', plural);
        var el = document.querySelector('.cart-count');
        if (el) el.textContent = c.item_count;
        else if (c.item_count > 0) {
          var icon = document.querySelector('.icon-btn[aria-label="Carrinho"]');
          if (icon) {
            var span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = c.item_count;
            icon.appendChild(span);
          }
        }
      });
    })
    .catch(function(){
      btn.textContent = 'Erro';
      setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 1400);
    });
  });
})();

/* Scroll reveal */
(function(){
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* .pdp-buy saiu daqui de proposito: o botao de comprar nunca deve comecar
     invisivel esperando um observador disparar. */
  var sel = '.sec-hd, .trust-item, .pcard, .kit-card, .tcard, .timeline-step, .faces-tag, .faces-title, .faces-text, .faces-feat, .faces-cta, .faces-img, .email-inner, .page-hero-inner, .contact-card, .contact-map-wrap, .pdp-gallery-main, .empty-state, .timeline-cta';
  var els = document.querySelectorAll(sel);
  var groups = new Map();
  els.forEach(function(el){
    el.classList.add('ff-reveal');
    var p = el.parentElement;
    var i = groups.get(p) || 0;
    el.style.setProperty('--ffd', Math.min(i * 90, 450) + 'ms');
    groups.set(p, i + 1);
  });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) { en.target.classList.add('ff-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px 80px 0px' });
  els.forEach(function(el){ io.observe(el); });

  /* Rede de seguranca: em rolagem rapida, aba em segundo plano ou JS engasgado,
     o observador pode nao disparar e o bloco fica preto. Passados 2,5s tudo
     aparece de qualquer forma. A animacao continua para quem rola devagar. */
  setTimeout(function(){
    els.forEach(function(el){
      if (!el.classList.contains('ff-in')) { el.classList.add('ff-in'); io.unobserve(el); }
    });
  }, 2500);
})();

/* Mantem a barra de categorias colada logo abaixo do bloco fixo do topo.
   Mede o GRUPO inteiro (tarja de aviso + header), nao so o .site-header. */
(function(){
  var topo = document.querySelector('.ff-topo-fixo')
          || document.querySelector('.site-header');
  if (!topo) return;
  function sync(){
    var h = Math.round(topo.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--header-h', h + 'px');
  }
  sync();
  window.addEventListener('resize', sync);
  window.addEventListener('load', sync);
  if (window.ResizeObserver) new ResizeObserver(sync).observe(topo);
})();
